import { FC, useEffect } from 'react';
import { Field } from 'redux-form';

import ThemedFormRadioGroup from 'inquiry/components/InputRadioGroup/ThemedFormRadioGroup';
import { useApply, useValidators } from 'inquiry/lib/jsonLogic';
import { InputRadioGroupComponent } from 'lib/interfaces/ui-components';
import isEmpty from 'lib/utils/formValidation/isEmpty';
import { UiComponentActionsApi } from 'verify/lib/interfaces/uiComponent';
import { Inquiry } from 'verify/models/inquiry';

interface InputRadioGroupProps {
  component: InputRadioGroupComponent;
  inquiry: Inquiry;
  actionsApi: UiComponentActionsApi;
}

const InputRadioGroup: FC<InputRadioGroupProps> = ({
  component,
  inquiry,
  actionsApi,
}: InputRadioGroupProps) => {
  const { disabled, hidden, label, optional, options, prefill, validations } = component.attributes;

  const formField = component.name;

  const apply = useApply(formField, inquiry.attributes['next-step'].name);
  const validators = useValidators({ hidden, optional, validations });

  // TODO: figure out how to test this
  const isHidden = apply<boolean>(hidden);

  useEffect(() => {
    if (isHidden) {
      // Setting to '' removes the field value from form state entirely, unlike null which sets value to null.
      actionsApi.setField(formField, '');
    } else if (!isHidden && !isEmpty(prefill)) {
      actionsApi.setField(formField, prefill);
    }
  }, [isHidden]);

  if (isHidden) {
    return null;
  }

  return (
    <Field
      id={formField}
      name={formField}
      component={ThemedFormRadioGroup}
      options={options}
      disabled={apply<boolean>(disabled)}
      validate={validators}
      label={label}
      styles={component.styles}
    />
  );
};

export default InputRadioGroup;
